// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionCard-cls1__tB","cls2":"SuggestionCard-cls2__V9 SuggestionCard-cls1__tB"};